import { IonLabel, IonList, IonListHeader } from "@ionic/react";
import { Planning, Timesheet } from "@/api";
import DayPlanningCard from "@components/DayPlanningCard.tsx";
import { useCallback, useState } from "react";
import EditTimesheetModal from "@components/Modals/EditTimesheetModal.tsx";

export interface GroupedDayPlanningCardProps {
  date: string;
  items: Planning[];
}
export default function GroupedDayPlanningCard({
  date,
  items,
}: GroupedDayPlanningCardProps) {
  const [showEditTimesheet, setShowEditTimesheet] = useState<boolean>(false);
  const [createdTimesheet, setCreatedTimesheet] = useState<
    Timesheet | undefined
  >(undefined);

  const handleEnterHours = useCallback((planning?: Planning) => {
    if (!planning) return;

    const timesheet: Timesheet = {
      created_at: "",
      source: "mobile",
      updated_at: "",
      date: planning.date,
      hours: 0,
      project_id: planning.project_id,
    };

    setCreatedTimesheet(timesheet);
    setShowEditTimesheet(true);
  }, []);

  const handleCloseTimesheet = useCallback(() => {
    setShowEditTimesheet(false);
    setCreatedTimesheet(undefined);
  }, []);

  return (
    <IonList lines="full">
      <EditTimesheetModal
        timesheet={createdTimesheet}
        showModal={showEditTimesheet}
        handleClose={() => handleCloseTimesheet()}
      />
      <IonListHeader>
        <IonLabel>
          {new Date(date + "T00:00:00").toLocaleDateString("nl-NL", {
            weekday: "long",
            day: "numeric",
            month: "long",
          })}
        </IonLabel>
      </IonListHeader>

      {items.map((item) => (
        <DayPlanningCard
          key={item.id}
          item={item}
          onClick={() => handleEnterHours(item)}
        />
      ))}
    </IonList>
  );
}
